module.exports = __webpack_public_path__ + "img/landing-invest-banner-mark.c6e7eca9.svg";